// Token storage utilities
const TOKEN_KEY = 'docs_frame_jwt';
const TOKEN_EXPIRY_KEY = 'docs_frame_jwt_expiry';

export function saveToken(token: string): void {
  try {
    localStorage.setItem(TOKEN_KEY, token);
    
    // Decode JWT to get expiry (simple base64 decode, no verification)
    const payload = JSON.parse(atob(token.split('.')[1]));
    if (payload.exp) {
      localStorage.setItem(TOKEN_EXPIRY_KEY, payload.exp.toString());
    }
  } catch (error) {
    console.error('Failed to save token:', error);
  }
}

export function getToken(): string | null {
  try {
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) return null;

    // Check if token is expired
    const expiry = localStorage.getItem(TOKEN_EXPIRY_KEY);
    if (expiry) {
      const expiryTime = parseInt(expiry, 10) * 1000; // Convert to milliseconds
      if (Date.now() >= expiryTime) {
        clearToken();
        return null;
      }
    }

    return token;
  } catch (error) {
    console.error('Failed to get token:', error);
    return null;
  }
}

export function clearToken(): void {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(TOKEN_EXPIRY_KEY);
}

export function isAuthenticated(): boolean {
  return getToken() !== null;
}
